import { FC, useCallback, useState } from 'react';
import { mutate } from 'swr';
import toast from 'react-hot-toast';

import { useAuth } from '@hooks/Auth';

import ButtonMighty from '@components/elements/ButtonMighty';
import Dialog from '@components/elements/Dialog';
import { unassignCompanyUser } from '@sdk/managers/UsersManager';

const LeaveCompanyButton: FC = () => {
  const { dbUser, company, companyAdmin, refetch } = useAuth();

  const [modal, setModal] = useState<boolean>(false);
  const hideModal = useCallback(() => setModal(false), [setModal]);
  const showModal = useCallback(() => setModal(true), [setModal]);

  const onSubmit = async () => {
    try {
      if (!dbUser?.id || !dbUser?.username) {
        throw new Error('Unexpected error.');
      }
      if (!companyAdmin?.id) {
        throw new Error('You are not in a company.');
      }
      console.log(companyAdmin);
      const res = await toast.promise(unassignCompanyUser(companyAdmin?.id), {
        loading: 'Leaving company',
        success: 'Successfully left company',
        error: (err) => err.error || err.message || 'Failed to leave company',
      });
      console.log('leaveCompany res', res);
      const [newAuth] = await Promise.all([
        refetch(),
        mutate(['/user/company', dbUser.id]),
        mutate(['/user/company/domain', dbUser.id]),
      ]);
      console.log(newAuth);
    } catch (err: any) {
      console.log('Leave unexpected error', err);
    } finally {
      hideModal();
    }
  };

  return (
    <>
      <Dialog
        className="text-center text-black bg-yellow"
        title={`Confirm to leave ${company?.name}`}
        content={
          <div>
            <p className="mb-4 text-sm">You are leaving your company.</p>
          </div>
        }
        open={modal}
        onCancel={hideModal}
        onConfirm={onSubmit}
      />
      <ButtonMighty
        color="#FFFF00"
        borderColor="#ff1dfc"
        textColor="#5600fb"
        text="Leave company"
        onClick={showModal}
      />
    </>
  );
};

export default LeaveCompanyButton;
